"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTicketingThankYouPreviewTicketCtas = exports.isWebBasedTicketsEligible = void 0;
const ticketing_1 = require("../enums/ticketing");
const WEB_BASED_TICKET_CATEGORIES = [
    ticketing_1.TicketingFormCategory.Event,
    ticketing_1.TicketingFormCategory.Custom,
    ticketing_1.TicketingFormCategory.Lottery,
    ticketing_1.TicketingFormCategory.Sweepstakes,
];
const isWebBasedTicketsEligible = ({ formCategory, generateQrCode, }) => {
    return WEB_BASED_TICKET_CATEGORIES.includes(formCategory) && Boolean(generateQrCode);
};
exports.isWebBasedTicketsEligible = isWebBasedTicketsEligible;
const getTicketingThankYouPreviewTicketCtas = ({ formCategory, generateQrCode, webBasedTicketPlaceholderUrl, }) => {
    const hasQrCode = Boolean(generateQrCode);
    const isWebBased = (0, exports.isWebBasedTicketsEligible)({
        formCategory: formCategory,
        generateQrCode,
    });
    return {
        webBasedEventTicketUrl: isWebBased ? webBasedTicketPlaceholderUrl : "",
        eTicketUrl: hasQrCode && !isWebBased ? undefined : "",
        hasWalletButtons: hasQrCode && formCategory !== ticketing_1.TicketingFormCategory.Shop,
    };
};
exports.getTicketingThankYouPreviewTicketCtas = getTicketingThankYouPreviewTicketCtas;
